import { createActions, handleActions } from 'redux-actions';

const initState = {
  topData: [],
  middleData: [],
  bottomData: [],
  fetching: false,
  error: null,
};

export const creators = createActions({
  CASHFLOW_TOP_REQUEST: (selectedYears, company, year, month, dimDate) => ({
    selectedYears,
    company,
    year,
    month,
    dimDate,
  }),
  CASHFLOW_MIDDLE_REQUEST: (dimDateArray, company, year, month, dimDateValue) => ({
    dimDate: dimDateArray,
    company,
    year,
    month,
    dimDateValue,
  }),
  CASHFLOW_BOTTOM_REQUEST: (selectedYears, company, year, month, dimDate) => ({
    selectedYears,
    company,
    year,
    month,
    dimDate,
  }),
  CASHFLOW_SUCCESS: (payload) => payload,
  CASHFLOW_FAILURE: (payload) => payload,
});

const topReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const middleReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const bottomReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    CASHFLOW_TOP_REQUEST: topReducer,
    CASHFLOW_MIDDLE_REQUEST: middleReducer,
    CASHFLOW_BOTTOM_REQUEST: bottomReducer,
    CASHFLOW_SUCCESS: successReducer,
    CASHFLOW_FAILURE: failureReducer,
  },
  initState,
);
